<template>
  <div class="noShadow" v-loading="isLoading">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover placement="right-bottom" title="条件检索" trigger="click" v-model="searchVisible">
          <searchForm
            @startSearch="handleTableSearch"
            @cancleSearch="handleCancleSeach"
            @showSearchForm="showSearchForm"
          ></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag :searchTagList="searchTagList" @handleDelOne="handleDelOne"></navTopTag>
      </div>
      <div>
        <el-button size="mini" type="primary" @click="handleOrder" :disabled="createOrderBtn">帮老人下单</el-button>
      </div>
    </div>
    <BaseStatistics :statisticData="baseStaArr"></BaseStatistics>
    <div>
      <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane label="所有数据" name="all"></el-tab-pane>
        <el-tab-pane label="消费记录" name="consume"></el-tab-pane>
        <el-tab-pane label="充值记录" name="add"></el-tab-pane>
        <el-tab-pane label="补助发放记录" name="grant"></el-tab-pane>
        <el-tab-pane label="清算" name="reset"></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs>
      <div class="tableContainer">
        <baseTable
          :columns="allTableObj.columns"
          :dataList="allTableObj.dataList"
          :options="allTableObj.options"
          :loadObj="allTableObj.loadObj"
          :operationColumn="allTableObj.operationColumn"
          :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event,allTableObj)"
          @dataCurrentChange="handleCurrentChange($event,allTableObj)"
        ></baseTable>
      </div>
    </div>
    <el-dialog center title="账单详情" :visible.sync="showBillDetail" :append-to-body="true">
      <el-form size="mini" labelWidth="150px" labelPosition="right">
        <el-form-item label="记录类型">
          <span>{{detailObj.type}}</span>
        </el-form-item>
        <el-form-item label="时间">
          <span>{{detailObj.payTime}}</span>
        </el-form-item>
        <el-form-item label="老人姓名">
          <span>{{detailObj.theOldName}}</span>
        </el-form-item>
        <el-form-item label="交易金额">
          <span>{{detailObj.money}}</span>
        </el-form-item>
        <el-form-item label="个人自付">
          <span>{{detailObj.selfPay}}</span>
        </el-form-item>
        <el-form-item label="基础补助">
          <span>{{detailObj.grantPay}}</span>
        </el-form-item>
        <!-- <el-form-item label="孝善基金">
          <span>{{detailObj.fundPay}}</span>
        </el-form-item>-->
        <el-form-item label="收/付款方">
          <span>{{detailObj.receiveName}}</span>
        </el-form-item>
        <el-form-item label="结算时间">{{detailObj.settleTime}}</el-form-item>
        <el-form-item label="是否已结算">{{detailObj.isSettle}}</el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="typeSelectShow" center>
      <el-form labelWidth="160px" labelPosition="right" size="mini">
        <el-form-item label="选择订单类型">
          <el-select v-model="orderType">
            <el-option label="上门服务" value="1"></el-option>
            <el-option label="送餐" value="2"></el-option>
            <el-option label="养老机构" value="3"></el-option>
            <el-option label="日间照料中心" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="selectOrderType">确定</el-button>
          <el-button @click="()=>{this.typeSelectShow=false}">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "./_component/search-form";
import { request } from "https";
// import $ from "jquery";
import {
  getOlderList,
  delOneOrg,
  getProviderEval,
  getProviderBill
} from "@/services/all-api.js";
import { axios } from "@/config/httpConfig.js";
import { mapState } from "vuex";
export default {
  components: {
    searchForm
  },
  computed: {
    ...mapState(["oneOlder"])
  },
  data() {
    return {
      createOrderBtn: false,
      orderType: "",
      typeSelectShow: false,
      baseStaArr: [
        { name: "基本补贴", number: "", value: "grant" },
        // { name: "孝善基金", number: "", value: "fund" },
        { name: "个人充值", number: "", value: "person" }
      ],
      detailObj: {},
      showBillDetail: false,
      isLoading: false,
      searchTagList: [],
      searchVisible: false,
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "60px",
            align: "center"
          },
          {
            prop: "payTime",
            label: "收/付款时间",
            align: "center"
          },
          {
            prop: "money",
            label: "交易金额",
            align: "center"
          },
          {
            prop: "dealType",
            label: "交易类型",
            align: "center"
          },
          {
            prop: "selfPay",
            label: "个人自付",
            align: "center",
            render: (h, params) => {
              return h("span", { style: params.row.type === 2 || params.row.type === 0 || params.row.type === 4 ? "color:#F56C6C" : "color:#67C23A" }, !params.row.selfPay ? "-" : params.row.type === 0 || params.row.type === 2 || params.row.type === 4 ? `- ${params.row.selfPay}` : params.row.type === 3 || params.row.type === 1 ? `+ ${params.row.selfPay}` : "")
            }
          },
          {
            prop: "grantPay",
            label: "基础补助",
            align: "center",
            render: (h, params) => {
              return h("span", { style: params.row.type === 2 || params.row.type === 0 || params.row.type === 4 ? "color:#F56C6C" : "color:#67C23A" }, !params.row.grantPay ? "-" : (params.row.type === 2 || params.row.type === 0 || params.row.type === 4) ? `- ${params.row.grantPay}` : params.row.type === 3 || params.row.type === 1 ? `+ ${params.row.grantPay}` : "")
            }
          },
          // {
          //   prop: "fundPay",
          //   label: "孝善基金",
          //   align: "center",
          //   render: (h, params) => {
          //     return h("span", { style: params.row.type === 2 || params.row.type === 0 || params.row.type === 4 ? "color:#F56C6C" : "color:#67C23A" }, !params.row.fundPay ? "-" : (params.row.type === 2 || params.row.type === 0 || params.row.type === 4) ? `- ${params.row.fundPay}` : params.row.type === 3 || params.row.type === 1 ? `+ ${params.row.fundPay}` : "")
          //   }
          // },
          {
            prop: "receiveName",
            label: "收款方",
            align: "center"
          }
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        consumeDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        addDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        grantDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        resetDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              disabled: false,
              style: "font-size:16px",
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            }
          ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    };
  },
  methods: {
    selectOrderType() {
      switch (this.orderType) {
        case "1":
          this.routeTo({ path: '/orders/service/create', query: { oneOldGid: this.oneOlder.theOldGid } });
          break;
        case "2":
          this.routeTo({ path: '/orders/dinner/create', query: { oneOldGid: this.oneOlder.theOldGid } });
          break;
        case "3":
          this.routeTo({ path: '/orders/beadhouse/create', query: { oneOldGid: this.oneOlder.theOldGid } });
          break;
        case "4":
          this.routeTo({ path: '/orders/daycare/create', query: { oneOldGid: this.oneOlder.theOldGid } });
          break;
      }
    },
    handleOrder() {
      this.typeSelectShow = true
    },
    getOlderAccountStastic() {
      const reqObj = {
        theOldGid: this.oneOlder.theOldGid
      };
      this.$xiaLaList.getOlderAccountStastic(reqObj).then(res => {
        this.baseStaArr = this.$baseFunc.getStasticCommon(res, this.baseStaArr);
      });
    },
    showSearchForm() {
      this.searchVisible = true;
    },
    listTrans(obj) {
      const result = {
        data: obj.data.map((item, i) => ({
          num: obj.index * obj.size + i + 1,
          gid: item.gid,
          theOldGid: item.theOldGid,
          theOldName: item.theOldName || "-",
          providerGid: item.serviceProviderGid || "-",
          payTime: item.time || "-",
          money: item.amount || "-",
          selfPay: item.personPayment || "",
          grantPay: item.grantPayment || "",
          fundPay: item.fundPayment || "",
          diningPay: item.diningPayment || "-",
          receiveName: item.serviceProviderName || "-",
          dealType: item.type === 0 ? "消费" : item.type === 1 ? "补助发放" : item.type === 2 ? "结算" : item.type === 3 ? "充值" : item.type === 4 ? "清算" : "",
          type: parseInt(item.type),
          isSettle: item.isSettle === true ? "已结算" : "未结算",
          settleTime: item.settleTime || "-"
        })),
        total: obj.total,
        index: obj.index,
        size: obj.size
      };
      return result;
    },
    //首次加载
    firstGet(obj) {
      var that = this;
      this.isLoading = true;
      function getAll() {
        return getProviderBill({
          index: 0, size: 20, theOldGid: that.oneOlder.theOldGid
        })
      }
      function getConsume() {
        return getProviderBill({
          index: 0,
          size: 20,
          type: 0,
          theOldGid: that.oneOlder.theOldGid
        });
      }
      function getAdd() {
        return getProviderBill({
          index: 0,
          size: 20,
          type: 3,
          theOldGid: that.oneOlder.theOldGid
        });
      }
      function getGrant() {
        return getProviderBill({
          index: 0,
          size: 20,
          type: 1,
          theOldGid: that.oneOlder.theOldGid
        });
      }
      function getReset() {
        return getProviderBill({
          index: 0,
          size: 20,
          type: 4,
          theOldGid: that.oneOlder.theOldGid
        })
      }
      this.$axios
        .all([getAll(), getConsume(), getAdd(), getGrant(), getReset()])
        .then(
          this.$axios.spread((all, consume, add, grant, reset) => {
            this.isLoading = false;
            let allRes = this.listTrans(all.data)
            let consumeRes = this.listTrans(consume.data);
            let addRes = this.listTrans(add.data);
            let grantRes = this.listTrans(grant.data);
            let resetRes = this.listTrans(reset.data)
            //所有数据
            this.allTableObj.allDataNow.dataList = allRes.data
            this.allTableObj.allDataNow.total = allRes.total;
            this.allTableObj.allDataNow.currentPage = 1;
            this.allTableObj.allDataNow.pageSize = 20;
            //消费记录
            this.allTableObj.consumeDataNow.dataList = consumeRes.data;
            this.allTableObj.consumeDataNow.total = consumeRes.total;
            this.allTableObj.consumeDataNow.currentPage = 1;
            this.allTableObj.consumeDataNow.pageSize = 20;
            //充值记录
            this.allTableObj.addDataNow.dataList = addRes.data;
            this.allTableObj.addDataNow.total = addRes.total;
            this.allTableObj.addDataNow.currentPage = 1;
            this.allTableObj.addDataNow.pageSize = 20;
            //补贴发放记录
            this.allTableObj.grantDataNow.dataList = grantRes.data;
            this.allTableObj.grantDataNow.total = grantRes.total;
            this.allTableObj.grantDataNow.currentPage = 1;
            this.allTableObj.grantDataNow.pageSize = 20;
            //清算记录
            this.allTableObj.resetDataNow.dataList = resetRes.data;
            this.allTableObj.resetDataNow.total = resetRes.total
            this.allTableObj.resetDataNow.currentPage = 1
            this.allTableObj.resetDataNow.pageSize = 20
            // this.allTableObj.
            //当前表格赋值
            this.$nextTick(() => {
              this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
              this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
              this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
              this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
            });
          })
        )
        .catch(() => {
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //分页检索加载
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      getProviderBill({ ...reqobj, theOldGid: this.oneOlder.theOldGid })
        .then(res => {
          let transData = this.listTrans(res.data).data
          if (flag == "all") {
            obj.allDataNow.dataList = transData;
            obj.allDataNow.total = res.data.total
            obj.fenyeObj.currentPage = obj.allDataNow.currentPage
            obj.fenyeObj.pageSize = obj.allDataNow.pageSize
            obj.dataList = transData
            obj.fenyeObj.total = obj.allDataNow.total
            return false
          }
          if (flag == "consume") {
            obj.consumeDataNow.dataList = transData
            obj.consumeDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.consumeDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.consumeDataNow.pageSize;
            obj.dataList = transData
            obj.fenyeObj.total = obj.consumeDataNow.total;
            return false;
          }
          else if (flag == "grant") {
            obj.grantDataNow.dataList = transData
            obj.grantDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.grantDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.grantDataNow.pageSize;
            obj.dataList = transData
            obj.fenyeObj.total = obj.grantDataNow.total;
            return false;
          }
          else if (flag == "add") {
            obj.addDataNow.dataList = transData
            obj.addDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.addDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.addDataNow.pageSize;
            obj.dataList = transData
            obj.fenyeObj.total = obj.addDataNow.total;
            return false;
          }
          else if (flag === "reset") {
            obj.resetDataNow.dataList = transData;
            obj.resetDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.resetDataNow.currentPage
            obj.fenyeObj.pageSize = obj.resetDataNow.pageSize
            obj.dataList = transData;
            obj.fenyeObj.total = obj.resetDataNow.total
          }
          else if (flag == "search") {
            obj.searchDataNow.dataList = transData
            obj.searchDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
            obj.dataList = transData
            obj.fenyeObj.total = obj.searchDataNow.total;
            return false;
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getMoneyTag(
        this.getOrderSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      let endSearch = {
        type: i.searchData.type,
        starttime: i.searchData.timeRange ? i.searchData.timeRange[0] : "",
        endtime: i.searchData.timeRange ? i.searchData.timeRange[1] : ""
      };
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        ...endSearch
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          type: 1,
          ...obj
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    tabClick(i) {
      if (i.name === "all") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "consume") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.consumeDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.consumeDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.consumeDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.consumeDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "add") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.addDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.addDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.addDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.addDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "grant") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.grantDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.grantDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.grantDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.grantDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "reset") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.resetDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.resetDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.resetDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.resetDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "search") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.searchDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.searchDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.searchDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.searchDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
    },

    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          theOldGid: this.oneOlder.theOldGid
        };
      }
      else if (obj.currentTab == "consume") {
        obj.consumeDataNow.currentPage = 1;
        obj.consumeDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 0,
          theOldGid: this.oneOlder.theOldGid
        };
      } else if (obj.currentTab == "add") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 3,
          theOldGid: this.oneOlder.theOldGid
        };
      }
      else if (obj.currentTab == "grant") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 1,
          theOldGid: this.oneOlder.theOldGid
        };
      }
      else if (obj.currentTab == "reset") {
        obj.resetDataNow.currentPage = 1;
        obj.resetDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          type: 4,
          theOldGid: this.oneOlder.theOldGid
        };
      }
      else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          theOldGid: this.oneOlder.theOldGid,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize,
          theOldGid: this.oneOlder.theOldGid
        };
      }
      else if (flag == "consume") {
        obj.consumeDataNow.currentPage = i;
        obj.consumeDataNow.pageSize = obj.consumeDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.consumeDataNow.pageSize,
          type: 0,
          theOldGid: this.oneOlder.theOldGid
        };
      } else if (flag === "add") {
        obj.addDataNow.currentPage = i;
        obj.addDataNow.pageSize = obj.addDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.addDataNow.pageSize,
          type: 3,
          theOldGid: this.oneOlder.theOldGid
        }
      }
      else if (flag == "grant") {
        obj.grantDataNow.currentPage = i;
        obj.grantDataNow.pageSize = obj.grantDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.grantDataNow.pageSize,
          type: 1,
          theOldGid: this.oneOlder.theOldGid
        }
      }
      else if (flag == "reset") {
        obj.resetDataNow.currentPage = i;
        obj.resetDataNow.pageSize = obj.resetDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.resetDataNow.pageSize,
          type: 4,
          theOldGid: this.oneOlder.theOldGid
        }
      }
      else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          theOldGid: this.oneOlder.theOldGid,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleDetail(i, j) {
      this.showBillDetail = true;
      this.detailObj = { ...j }
    }
  },
  mounted() {
    this.getOlderAccountStastic();
    this.firstGet(this.allTableObj);
  }
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  padding-bottom: 0px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.noShadow {
  box-shadow: 0 0 0 0;
  border: 0;
  padding: 20px 0px;
}
.tableContainer {
  height: calc(100vh - 490px);
}
.tableContainer > div {
  height: 90%;
}
</style>

